(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gb-footer-navigation')) {
  customElements.define('gb-footer-navigation', class extends HTMLElement {
    connectedCallback() {
      this.query = window.matchMedia('(max-width: 749px)');
      this.update = () => this.querySelectorAll('details').forEach(group => {
        group.open = !this.query.matches;
        const summary = group.querySelector('summary');
        if (this.query.matches) summary.removeAttribute('tabindex');
        else summary.setAttribute('tabindex', '-1');
      });
      this.update();
      this.query.addEventListener('change', this.update);
    }
    disconnectedCallback() { this.query?.removeEventListener('change', this.update); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gb-pad-shared"]) return;
  try {
    
(() => {
  const compoundParameters = ['filter.p.m.custom.compound', 'filter.p.m.custom.compounds'];
  const rangeStates = new WeakMap();
  const rangeCache = new Map();
  const rangeContext = (group, current) => {
    const target = new URL(group.dataset.gbRangeTarget, current.origin);
    target.search = current.search;
    target.hash = '';
    [...compoundParameters, 'page', 'section_id', 'sections'].forEach((key) => target.searchParams.delete(key));
    let aliasExpanded = false;
    const modelAliases = group.dataset.gbRangeModelAliases || 'Advocate|HEL-Advocate';
    const codeAliases = group.dataset.gbRangeCodeAliases || (current.pathname.startsWith('/fr/') ? 'ADV 1|AVANCE 1' : '');
    [['model', modelAliases], ['caliper_number_code', codeAliases]].forEach(([key, aliasesValue]) => {
      const aliases = (aliasesValue || '').split('|').filter(Boolean);
      const parameter = 'filter.p.m.custom.' + key;
      const selected = target.searchParams.getAll(parameter).flatMap((value) => value.split(','));
      if (aliases.length && selected.some((value) => aliases.includes(value))) {
        if (aliases.some((value) => !selected.includes(value))) aliasExpanded = true;
        target.searchParams.delete(parameter);
        [...new Set([...selected, ...aliases])].forEach((value) => target.searchParams.append(parameter, value));
      }
    });
    const scope = JSON.parse(group.dataset.gbRangeScope || '{}');
    let compatible = true;
    Object.entries(scope).forEach(([parameter, allowed]) => {
      const selected = target.searchParams.getAll(parameter).flatMap((value) => value.split(','));
      const retained = selected.length ? selected.filter((value) => allowed.includes(value)) : allowed;
      if (!retained.length) compatible = false;
      target.searchParams.delete(parameter);
      [...new Set(retained)].forEach((value) => target.searchParams.append(parameter, value));
    });
    return { target, compatible, aliasExpanded, key: target.toString() + (compatible ? '' : '|incompatible') };
  };
  const setRange = (card, target, parameter, values, available) => {
    const href = new URL(target);
    values.forEach((value) => href.searchParams.append(parameter, value));
    href.hash = 'ProductGridContainer';
    const unavailable = available === false;
    card.dataset.gbRangeState = unavailable ? 'unavailable' : available === true ? 'available' : 'pending';
    card.classList.toggle('gb-shared-tier--unavailable', unavailable);
    card.querySelector('[data-gb-range-status]').hidden = !unavailable;
    card.querySelector('[data-gb-range-arrow]').hidden = unavailable;
    if (unavailable) {
      card.removeAttribute('href');
      card.setAttribute('aria-disabled', 'true');
      card.setAttribute('tabindex', '-1');
    } else {
      card.href = href.toString();
      card.removeAttribute('aria-disabled');
      card.removeAttribute('tabindex');
    }
  };
  const applyRangeData = (group, context, data) => {
    if (!data || data.operator !== 'OR' || !compoundParameters.includes(data.parameter) || !Array.isArray(data.values)) throw new Error('Missing range facets');
    if (data.values.some((value) => typeof value.value !== 'string' || !Number.isFinite(value.count) || value.count < 0)) throw new Error('Invalid range counts');
    group.querySelectorAll('[data-gb-shared-tier]').forEach((card) => {
      const values = data.values.filter((value) => value.tier === card.dataset.gbSharedTier && Number(value.count) > 0).map((value) => value.value);
      setRange(card, context.target, data.parameter, [...new Set(values)], context.compatible && values.length > 0);
    });
  };
  const refreshRange = (group) => {
    const current = new URL(window.location.href);
    const context = rangeContext(group, current);
    let state = rangeStates.get(group);
    if (!state) {
      state = { key: null, sequence: 0, initial: true };
      rangeStates.set(group, state);
      if (!context.aliasExpanded && context.target.pathname === current.pathname && !Object.keys(JSON.parse(group.dataset.gbRangeScope || '{}')).length) {
        try {
          const data = JSON.parse(group.querySelector('[data-gb-range-facets]').textContent);
          applyRangeData(group, context, data);
          rangeCache.set(context.key, data);
        } catch (_) {}
      }
    }
    if (state.key === context.key && (!state.retryAfter || Date.now() < state.retryAfter)) return state.pending;
    state.key = context.key;
    state.retryAfter = 0;
    state.sequence += 1;
    const sequence = state.sequence;
    if (state.controller) state.controller.abort();
    group.removeAttribute('aria-busy');
    group.querySelectorAll('[data-gb-shared-tier]').forEach((card) => {
      setRange(card, context.target, 'filter.p.m.custom.compounds', card.dataset.gbRangeValues.split('|'), context.compatible ? null : false);
    });
    if (!context.compatible) return Promise.resolve();
    if (rangeCache.has(context.key)) {
      applyRangeData(group, context, rangeCache.get(context.key));
      return Promise.resolve();
    }
    const controller = new AbortController();
    state.controller = controller;
    const request = new URL(context.target);
    request.searchParams.set('section_id', group.dataset.gbRangeSection);
    const timeout = window.setTimeout(() => controller.abort(), 8000);
    group.setAttribute('aria-busy', 'true');
    state.pending = fetch(request.toString(), { signal: controller.signal, credentials: 'same-origin' })
      .then((response) => { if (!response.ok) throw new Error('Range request failed'); return response.text(); })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const element = doc.querySelector('[data-gb-range-facets]');
        if (!element) throw new Error('Missing range response');
        const data = JSON.parse(element.textContent);
        const handle = decodeURIComponent(context.target.pathname.split('/').filter(Boolean).pop());
        const expectedTheme = context.target.searchParams.get('preview_theme_id') || window.Shopify?.theme?.id;
        if (expectedTheme && String(data.theme) !== String(expectedTheme)) throw new Error('Wrong range theme');
        if (data.collection !== handle) throw new Error('Wrong range collection');
        if (state.sequence !== sequence) return;
        applyRangeData(group, context, data);
        rangeCache.set(context.key, data);
        if (rangeCache.size > 20) rangeCache.delete(rangeCache.keys().next().value);
      })
      .catch(() => { if (state.sequence === sequence) state.retryAfter = Date.now() + 10000; })
      .finally(() => {
        window.clearTimeout(timeout);
        if (state.sequence === sequence) group.removeAttribute('aria-busy');
      });
    return state.pending;
  };
  const refreshLinks = () => {
    document.querySelectorAll('[data-gb-range-cards]').forEach(refreshRange);
  };
  const preservePreviewView = () => {
    const current = new URL(window.location.href);
    if (current.searchParams.get('view') !== 'gorilla-brake-pads') return;
    document.querySelectorAll('facet-filters-form form').forEach((form) => {
      let input = form.querySelector('input[name="view"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'view';
        form.append(input);
      }
      input.value = 'gorilla-brake-pads';
    });
    document.querySelectorAll('facet-remove a, .facets__reset, .mobile-facets__clear, .pagination__item, .gb-shared-model, #ProductGridContainer a[href]').forEach((link) => {
      const target = new URL(link.href, window.location.origin);
      if (target.origin !== current.origin) return;
      if (target.pathname !== current.pathname && !link.classList.contains('gb-shared-model')) return;
      target.searchParams.set('view', 'gorilla-brake-pads');
      if (link.href !== target.toString()) link.href = target.toString();
    });
    document.querySelectorAll('[data-gb-shared-prepared-link-handles]').forEach((section) => {
      const preparedHandles = new Set(section.dataset.gbSharedPreparedLinkHandles.split('|').filter(Boolean));
      if (!preparedHandles.size) return;
      section.querySelectorAll('.gb-shared-fitment .gb-shared-prose a[href], .gb-shared-answer a[href]').forEach((link) => {
        const target = new URL(link.href, current.origin);
        if (target.origin !== current.origin) return;
        const collectionPath = target.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z0-9]+)?\/)?collections\/([^/]+)\/?$/i);
        if (!collectionPath) return;
        let handle;
        try { handle = decodeURIComponent(collectionPath[1]); } catch { return; }
        if (!preparedHandles.has(handle)) return;
        target.searchParams.set('view', 'gorilla-brake-pads');
        if (link.href !== target.toString()) link.href = target.toString();
      });
    });
  };
  const refresh = () => {
    refreshLinks();
    preservePreviewView();
  };
  let gridObserver;
  const initialize = () => {
    refresh();
    const grid = document.getElementById('ProductGridContainer');
    if (grid) {
      if (gridObserver) gridObserver.disconnect();
      gridObserver = new MutationObserver(refresh);
      gridObserver.observe(grid, { childList: true, subtree: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  window.addEventListener('pageshow', refresh);
  window.addEventListener('popstate', refresh);
  document.addEventListener('shopify:section:load', initialize);
  ['pointerdown', 'focusin', 'contextmenu', 'click'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      if (!(event.target instanceof Element)) return;
      const rangeCard = event.target.closest('[data-gb-shared-tier]');
      if (rangeCard) {
        refreshRange(rangeCard.closest('[data-gb-range-cards]'));
        if (rangeCard.getAttribute('aria-disabled') === 'true') event.preventDefault();
      }
      if (event.target.closest('facet-filters-form, facet-remove, .pagination, .gb-shared-model, .gb-shared-fitment, .gb-shared-answer')) preservePreviewView();
    }, true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
